<template>
  <div class="card-border position-relative">
    <slot />
    <div class="card-border-big position-absolute"></div>
  </div>
</template>

<script setup>

</script>
